import { render, staticRenderFns } from "./InputComp.vue?vue&type=template&id=aa893870&scoped=true&"
import script from "./InputComp.vue?vue&type=script&lang=js&"
export * from "./InputComp.vue?vue&type=script&lang=js&"
import style0 from "./InputComp.vue?vue&type=style&index=0&id=aa893870&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa893870",
  null
  
)

export default component.exports